import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { MOCK_URL_HEADER_MENU } from '@ibe.config';
import { INDRAHeaderMenuResponse } from '@ibe.models/header.indra.model.lib';
import { INDRAStorageService } from './storage.indra.service';
import { INDRAApiService } from './api.indra.service';


@Injectable({
  providedIn: 'root'
})
export class INDRAHeaderService {
	private language = new BehaviorSubject<string>(sessionStorage.getItem('language'));

	constructor(
		private http: HttpClient,
		private apiIndra: INDRAApiService,
		private storage: INDRAStorageService
	) { }

	public INDRA_getHeaderMenu(): Observable<INDRAHeaderMenuResponse> {
		return this.http.get<INDRAHeaderMenuResponse>(MOCK_URL_HEADER_MENU);
	}

	/*
	public getToken(): Observable<string> {
		const tokenURL = this.ibeAdminConfigService.getConfigurationValue('externalURLs.token');
		if (tokenURL != 'externalURLs.token') {
			const data = {
				username: 'devflytapapi',
				password: 'password',
				grant_type: 'password'
			};
			return this.http.post<string>(`${tokenURL}`, data);
		} else return new BehaviorSubject(undefined);
	}
	*/

	setLanguage(lang: string) {
        this.language.next(lang);
	}

	getLanguage(): Observable<any> {
        return this.language.asObservable();
    }

}
